import * as React from 'react'
import { Button, Form, Col, Row } from 'react-bootstrap'

import { ClientT } from '../../../../types/Users';
import config from '../../../../constants/config';
import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading';
import {  AxiosInstance } from '../../../../utils/RequestMethods';
import { generatePassword } from '../../../../utils/utilsT';

const colors = {
    red: "#cc0000",
    green: "#198c19",
}
interface PasswordProps {

    client: ClientT
}

const ChangePassword: React.FunctionComponent<PasswordProps> = (props): JSX.Element => {
    const [validated, setValidated] = React.useState(false);
    const [showInputPassword, setShowInputPassword] = React.useState(false);
    const [isHide, setIsHide] = React.useState(false);
    const [fields, setFields] = React.useState({
        password: "",
    });
    const [password, setPassword] = React.useState("");
    const form = React.useRef(null)

    const checkValidity = () => {
        let valid = password != ""
        // console.log("form",form)
        if (form) {
            let validityForm = form.current.checkValidity();
            // console.log("validityForm",validityForm)
            return (validityForm && valid)
        }
        return false
    }



    /**
     *
     * @param event
     * @returns
     */
    const save = async (event): Promise<string> => {
        event.preventDefault();
        if (!checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            setValidated(true)
            // return false;
            throw new Error("Required fields")
        }

        let params = {
            password: password,
        }

        try {
            let res = await AxiosInstance.post(`${config.url.clients}/${props.client.id}/change_password`, params)
            console.log("res", res)
            if (res && res.data) {

                setValidated(false)
                setTimeout(() => {
                    setPassword("")
                    setShowInputPassword(false)
                    setIsHide(false)
                }, 500);
                return 'Password saved.'
            }
        } catch (error) {

            throw new Error(error)

        }
    }


    return (
        <div className=" mt-2">

            <Button variant="light" style={{ margin: 0 }} onClick={() => {
                setShowInputPassword(true)
                setPassword(generatePassword(20))
            }}>  Set New Password</Button>

            {showInputPassword && <Form
                className="mt-2"
                // onSubmit={handleSubmit}
                noValidate
                ref={form}
                validated={validated}>
                <Row>
                    <Col xs={6}>

                        <Form.Group >
                            <Form.Label>New Password</Form.Label>
                            <Form.Control
                                type={isHide ? 'password' : "text"}
                                value={`${password}`}
                                className='input-material'
                                onChange={(e) => {
                                    setPassword(e.target.value)
                                }}
                                required={true}
                            />
                            <Form.Control.Feedback type="invalid">
                                Required.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <div className="d-flex flex-row  align-items-center" style={{ gap: 5, marginTop: 10, height: "100%" }}>
                            <Button variant="light" style={{ margin: 0, }} onClick={() => {
                                setIsHide(!isHide)
                            }}><i className={`fa ${isHide ? "fa-eye" : "fa-eye-slash"}`} />  Hide</Button>
                            <Button variant="light" style={{ margin: 0 }} onClick={() => {
                                setShowInputPassword(false)
                                setPassword("")
                            }}>  Cancel</Button>
                        </div>
                    </Col>

                </Row>
                {/* {result.loading && <>   <Spinner animation="border" /> Loading... </>}
                {result.showMsg && <span className="text-center" style={{ flex: 1, padding: 5, alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ color: result.isSuccess ? colors.green : colors.red }} >{result.msg}</span>
                </span>} */}
                <ButtonLoading
                    type="submit"
                    className="btn-primary"
                    variant="success"
                    style={{ margin: 0 }}
                    onClickFetching={async (e): Promise<string> => {
                        return await save(e)
                    }}
                >
                    Save New Password
                </ButtonLoading>
            </Form>}

        </div>
    )
}

export default ChangePassword
